// extracted by mini-css-extract-plugin
export default {"ticketPortal":"portal_ticketPortal__72Fna","ticketPortalText":"portal_ticketPortalText__xYgmO"};